import "./style.css";
import { renderLanding } from "./landing";
import { renderRoom } from "./room";

const app = document.getElementById("app") as HTMLElement;

function parseRoute(): { kind: "landing" } | { kind: "room"; id: string } {
  const path = window.location.pathname;
  const match = path.match(/^\/r\/([A-Za-z0-9_-]{4,32})\/?$/);
  if (match) return { kind: "room", id: match[1] };
  return { kind: "landing" };
}

let dispose: (() => void) | undefined;

function render() {
  if (dispose) {
    try {
      dispose();
    } catch (err) {
      console.error("dispose error", err);
    }
    dispose = undefined;
  }

  app.replaceChildren();
  const route = parseRoute();
  if (route.kind === "landing") {
    dispose = renderLanding(app);
  } else {
    dispose = renderRoom(app, route.id);
  }
}

window.addEventListener("popstate", render);

render();
